/* RESPONSIBLE TEAM: team-standalone */

import type { ConversationExcerptData } from '../definitions';
import type SalesforcePlatform from '../../salesforce';

export default class SalesforceConversationExcerpt implements ConversationExcerptData {
  private platform: SalesforcePlatform;

  constructor(platform: SalesforcePlatform) {
    this.platform = platform;
  }

  title(excerptsEnabled: boolean) {
    let defaultPrefix = 'fin-ai-agent.knowledge.content-sources.conversation-excerpts';
    let prefix = excerptsEnabled ? `${defaultPrefix}.enabled` : defaultPrefix;
    return this.platform.intl.t(`${prefix}.salesforce`);
  }

  get link() {
    return this.platform.salesforceConfig?.domain;
  }
}
